import { AuthUser } from '@/core/classes/Auth'
import { VideoFxBlurStrength, VideoFxConfig } from 'amazon-chime-sdk-js'
import { merge } from 'lodash'

const PREFERENCE_BACKGROUND_EFFECT_KEY = 'preferenceBackgroundEffect'

export function savePreferenceBackgroundToStorage(userId: string, preference: string) {
  localStorage.setItem(`${PREFERENCE_BACKGROUND_EFFECT_KEY}_${userId}`, preference)
}

export function getPreferenceBackgroundFromStorage(userId: string) {
  return localStorage.getItem(`${PREFERENCE_BACKGROUND_EFFECT_KEY}_${userId}`)
}

export function removePreferenceBackgroundFromStorage(userId: string) {
  localStorage.removeItem(`${PREFERENCE_BACKGROUND_EFFECT_KEY}_${userId}`)
}

export function getVideoFxDefaultConfig(): VideoFxConfig {
  return {
    backgroundBlur: {
      isEnabled: false,
      strength: 'high' as VideoFxBlurStrength,
    },
    backgroundReplacement: {
      isEnabled: false,
      backgroundImageURL: undefined,
      defaultColor: undefined,
    },
  }
}

export function getBlurEffectConfig(): VideoFxConfig {
  return merge(getVideoFxDefaultConfig(), { backgroundBlur: { isEnabled: true }, backgroundReplacement: { isEnabled: false } })
}

export function getBackgroundEffectConfig(imageUrl: string): VideoFxConfig {
  return merge(getVideoFxDefaultConfig(), {
    backgroundBlur: { isEnabled: false },
    backgroundReplacement: { isEnabled: true, backgroundImageURL: imageUrl },
  })
}
